import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class SettingsHttpService {

  public static SETTINGS_GET_URL = DevelopUtil.url('userSettings/get');
  public static SETTINGS_SET_URL = DevelopUtil.url('userSettings/set');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getSettings(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(SettingsHttpService.SETTINGS_GET_URL, this.requestOptions);
  }

  setSettings(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(SettingsHttpService.SETTINGS_SET_URL, this.requestOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/settings/settings.http.service.ts